import { expVal } from '@confluence/feature-experiments';

/**
 * Returns whether the current tenant or org has opted out of Remix. Either
 * config returning `true` opts the current user out.
 *
 * Read through the experiment client rather than `StatsigConfigurations` because
 * the dynamic config collection does not supply `orgId`, so org-level targeting
 * cannot be evaluated there.
 *
 * Opting out hides every entrypoint for generating or editing a Remix. It does
 * NOT stop an existing Remix from being viewed — rendering, resizing and
 * loading of already-generated content must keep working.
 *
 * Checked before any `cc-maui-experiment` evaluation so opted-out users never
 * fire a `cc-maui-experiment` exposure.
 */
export const isRemixOptedOut = (): boolean =>
	expVal('remix_opt_out_tenant_ids', 'value', false) ||
	expVal('remix_opt_out_org_ids', 'value', false);
